import { batch } from 'react-redux';
import { array } from 'fp-ts';
import { LoyaltyExtent, MultipleLoyaltyParameters } from '@mews-commander/data-access';
import { CommanderThunkAction, AsyncAction } from '@mews-commander/types';
import { createFetchAction } from '@mews-commander/utils';
import { setLoyaltyMemberships } from '../ducks/loyaltyMemberships';
import { setLoyaltyPrograms } from '../ducks/loyaltyPrograms';
import prefix from '../prefix';
import { setLoyaltyTiers } from '../ducks/loyaltyTiers';

const LOYALTIES_FETCH = prefix('LOYALTIES_FETCH');

const fetchLoyalties =
    ({
        accountIds,
        extent,
    }: Pick<MultipleLoyaltyParameters, 'accountIds'> & { extent: LoyaltyExtent }): CommanderThunkAction<AsyncAction> =>
    async (dispatch, getState, { repositories }) => {
        const promise = repositories.loyaltyMemberships
            .getAll({
                extent,
                accountIds,
            })
            .then(({ memberships, programs, tiers }) => {
                batch(() => {
                    if (memberships && array.isNonEmpty(memberships)) {
                        dispatch(setLoyaltyMemberships(memberships));
                    }
                    if (programs && array.isNonEmpty(programs)) {
                        dispatch(setLoyaltyPrograms(programs));
                    }
                    if (tiers && array.isNonEmpty(tiers)) {
                        dispatch(setLoyaltyTiers(tiers));
                    }
                });
            });

        return dispatch(createFetchAction(LOYALTIES_FETCH, promise));
    };

export const fetchLoyaltiesByAccountIds = ({ accountIds, extent }: { accountIds: string[]; extent: LoyaltyExtent }) =>
    fetchLoyalties({ accountIds, extent });
